/* eslint-disable react/no-multi-comp */
/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import { JsonLd } from 'react-schemaorg';
import uniqueId from 'lodash/uniqueId';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import map from 'lodash/map';
import filter from 'lodash/filter';
import indexOf from 'lodash/indexOf';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import formatDate from 'helpers/formatDate';
import absoluteUrl from 'helpers/absoluteUrl';
import { emit } from 'helpers/global-events';
import localStorage from 'helpers/local-storage';
import noScroll from 'helpers/noScroll';
import DataProvider from 'api/data-provider';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { authConnect, UserProp } from 'auth';
import Complaint from 'subsys/complaint';
import CardInfo from 'subsys/card-info';
import Icon, { iconTypes } from 'components/icon';
import { Thumb, FullScreenSlider } from 'components/image';
import DropDown, { close as ddClose } from 'components/drop-down';
import Button from 'components/button';
// import Share from 'components/share';
import CommentRules from 'components/comment-rules';
import Notification from 'components/notification';

import Editor from './editor';
import { CommentProp } from './shapes';

import translates from './comments-i18n.json';

export default class CommentDataWrap extends Component {
  static propTypes = {
    entity: PropTypes.string.isRequired,
    entityId: PropTypes.number.isRequired,
    isNew: PropTypes.bool,
    className: PropTypes.string,
    comment: PropTypes.shape(CommentProp),
    commentRef: PropTypes.func,
    noInteraction: PropTypes.bool,
    noVisitingCard: PropTypes.bool
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.isNew !== nextProps.isNew ||
      this.props.comment.id !== nextProps.comment.id ||
      this.props.comment.canEdit !== nextProps.comment.canEdit ||
      this.props.comment.canDelete !== nextProps.comment.canDelete
    );
  }

  render() {
    const { comment, commentRef, ...otherProps } = this.props;
    return (
      <div className="commentDataWrap" ref={commentRef}>
        <DataProvider
          ref={el => this.provider = el}
          url="domik/comments/comments-list"
          injectPropName="comment"
          updateEvent={`comment::${otherProps.entity}::ed::${comment.id}`}
          preloaded={comment}
          query={{
            id: comment.id,
            entity: otherProps.entity,
            entityId: otherProps.entityId,
            $auth: otherProps.auth.authenticated
          }}
          single
        >
          <Comment
            reload={this.reload}
            {...otherProps}
          />
        </DataProvider>
      </div>
    );
  }
}

const bemClassesComment = new Bem('comment');
const bemClassesCardInfo = new Bem('cardInfo');
const bemClassesDD = new Bem('dropDownList');

@authConnect()
@apiDecorator
@I18nHoc(translates)
class Comment extends Component {
  static propTypes = {
    entity: PropTypes.string.isRequired,
    entityId: PropTypes.number.isRequired,
    noInteraction: PropTypes.bool,
    noVisitingCard: PropTypes.bool,
    isNew: PropTypes.bool,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    checkPermission: PropTypes.func,
    clearAfterLoginTrigger: PropTypes.func,
    copyToClipboard: PropTypes.func,
    formController: PropTypes.string,
    comment: PropTypes.shape(CommentProp),
    reply: PropTypes.any, //eslint-disable-line
    reload: PropTypes.any, //eslint-disable-line
    fullRefresh: PropTypes.any, //eslint-disable-line
    subscribe: PropTypes.bool,
    autoHideReply: PropTypes.bool,
  };

  static contextTypes = {
    router: routerShape
  };

  static getDerivedStateFromProps(props) {
    return { isNew: props.isNew };
  }

  constructor(props, ctx) {
    super(props, ctx);

    this.uniqueId = uniqueId('comment::');
    this.comment = null;
    this.router = ctx.router;

    this.reply = this.reply.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
    this.replySubmitted = this.replySubmitted.bind(this);
    this.editSubmitted = this.editSubmitted.bind(this);
    this.votePlus = this.votePlus.bind(this);
    this.voteMinus = this.voteMinus.bind(this);
    this.setOld = this.setOld.bind(this);
    this.clipboardListener = this.clipboardListener.bind(this);
    this.closeDropDown = this.closeDropDown.bind(this);
    this.images = {
      quoteImages: [],
      postImages: []
    };
    this.imageSource = 'postImages';

    this.state = {
      reply: false,
      editing: false,
      highlighted: false,
      showPopup: false
    };
  }

  componentDidMount() {
    this.updateImg();
    if (this.commentPost) this.commentPost.addEventListener('click', this.onImageClick, false);
  }

  //TODO condition (nextProps.auth.afterLoginTrigger.id === this.uniqueId) is always false

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.auth.authenticated) {
  //     if (
  //       nextProps.auth.afterLoginTrigger &&
  //       nextProps.auth.afterLoginTrigger.id === this.uniqueId
  //     ) {
  //       nextProps.auth.afterLoginTrigger.action(null, nextProps.auth);
  //     }
  //   }
  // }

  setOld() {
    this.setState({ isNew: false });
  }

  updateImg() {
    const imgGroup = [...this.commentPost.querySelectorAll('img')];
    if (imgGroup.length) {
      const parent = document.createElement('div');
      parent.className = "attachesBlock";
      imgGroup.forEach(card => {
        card.className = "postImg";
        parent.appendChild(card);
      });
      this.commentPost.appendChild(parent);
    }
  }

  onImageClick =(e)=> {
    this.getAllImages(e);
    if (e.target.tagName.toLowerCase() === 'img' && e.target.classList.contains('postImg')) {
      this.selectedImageIndex =
        findIndex(
          this.images[this.imageSource],
          img => (img.x === e.target.x && img.y === e.target.y)
        );
      if (this.selectedImageIndex < 0) this.selectedImageIndex = 0;

      this.images[this.imageSource] = map(
        this.images[this.imageSource],
        (img) => {
          let src = img.src;
          if (src.indexOf('/images/orig/640x640/') >= 0) {
            src = src.replace(/640x640/g, 'full').replace(/\.jpg/g, '');
          }
          return {
            src,
            alt: img.alt || '',
            title: img.title
          };
        }
      );

      this.setState(
        { showPopup: true },
        () => noScroll()
      );
    }
  }

  getAllImages =(e)=> {
    const blockQuote = this.commentPost.getElementsByTagName('blockquote')[0] || null;
    if (e && blockQuote) {
      this.imageSource = 'quoteImages';
      this.images.quoteImages = blockQuote.getElementsByTagName('img');
      this.images.quoteImages = filter(this.images.quoteImages, it => it.classList.contains('postImg'));
    }
    if (blockQuote && !blockQuote.contains(e.target)) this.imageSource = 'postImages';

    this.images.postImages = this.commentPost.getElementsByTagName('img');
    this.images.postImages = filter(this.images.postImages,
      it => (it.classList.contains('postImg') &&
        findIndex(this.images.quoteImages, img => (img.x === it.x && img.y === it.y)) < 0)
    );
  }

  clipboardListener() {
    let domain = '';
    let pathname = '';
    let value = null;
    if (__CLIENT__) {
      domain = window.location.origin;
      pathname = this.router.location.pathname;
      value = `${domain}${pathname}#comment-${this.props.comment.id}`;
    }

    if (value) this.props.copyToClipboard(value, this.closeDropDown);
  }

  vote(vote) {
    const id = get(this, 'props.comment.id');
    const votedCommentIds = localStorage.get('votedCommentIds') || [];

    if (indexOf(votedCommentIds, id) > -1) return Notification.warning(this.i18n('alreadyVote'));

    this.api.get('action/comment/actions/vote', {
      queryString: {
        vote,
        id
      }
    })
      .then(() => {
        votedCommentIds.push(id);
        localStorage.emit('votedCommentIds', votedCommentIds);
        emit(`comment::${this.props.entity}::ed::${id}`);
      })
      .catch(error => reportError(error));
  }

  actionsCommon(auth = this.props.auth, action) {
    if (!auth.authenticated) {
      return this.props.actionDoLogin({
        id: this.uniqueId,
        action: () => {
          action();
          this.props.clearAfterLoginTrigger();
        }
      });
    }

    action();
  }

  reply(e, auth) {
    this.actionsCommon(auth, () => {
      this.props.reply(this);
      this.setState({
        reply: true
      });
    });
  }

  edit() {
    if (!this.props.auth.authenticated) return this.props.actionDoLogin();
    this.setState({
      editing: true
    });
  }

  delete() {
    this.api.delete('form/comment/editor/data', {
      postData: {
        id: this.props.comment.id
      }
    })
      .then(() => {
        emit(`comment::${this.props.entity}::add`);
        emit(`updateCommentsCount`);
        emit("updatePosts");
        // ddClose(this.ddRef);
        this.ddRef.getInstance().close();
      })
      .catch(error => reportError(error));
  }

  closeReply() {
    this.setState({ reply: false, editing: false });
  }

  votePlus() {
    //this.actionsCommon(this.props.auth, () => this.vote(1));
    this.vote(1);
  }

  voteMinus() {
    //this.actionsCommon(this.props.auth, () => this.vote(-1));
    this.vote(-1);
  }

  replySubmitted(data) {
    this.setState({ reply: false });
    this.props.fullRefresh(data);
  }

  editSubmitted() {
    this.setState({ editing: false });
  }

  closeDropDown() {
    // ddClose(this.ddRef);
    this.ddRef.getInstance().close();
    this.setState({ highlighted: true },
      () => setTimeout(() => this.setState({ highlighted: false }), 3000)
    );
  }

  showUserName(comment) {
    if (this.props.noInteraction || this.props.noVisitingCard) {
      return (
        <span {...bemClassesCardInfo('btn', 'cardInfo')}>
          <span {...bemClassesCardInfo('btnContent')}>
            <span {...bemClassesCardInfo('text')} children={comment.user_add_name} />
          </span>
        </span>
      );
    }

    return (
      <CardInfo
        contentPhoto={{ id: comment.avatar }}
        userName={comment.user_add_name}
        userId={comment.user_add}
      />
    );
  }

  renderEditor(props = {}) {
    return (
      <Editor
        formController={this.props.formController}
        entity={this.props.entity}
        entityId={this.props.entityId}
        auth={this.props.auth}
        checkPermission={this.props.checkPermission}
        addMsg={null}
        subscribe={this.props.subscribe}
        autoFocus
        {...props}
      />
    );
  }

  renderReply() {
    if (!this.props.auth.authenticated) return null;

    const editorProps = {
      className: 'commentsEditor commentsEditor_reply',
      parent: this.props.comment.id,
      onCommentSubmit: this.replySubmitted,
      updateEvent: 'add'
    };

    // TODO автоскрытие работает когда кликаешь вне едитора, не всегда это корректно
    // например выпадающее меню с иконками находятся вне едитора, правила комментирования
    // когда выбираешь иконку, то автоматически скрывается едитор
    if (this.props.autoHideReply) {
      editorProps.onCancel = () => this.setState({ reply: !this.state.reply });
    }

    if (this.state.reply) {
      return this.renderEditor(editorProps);
    }
  }

  renderEditBtn(comment) {
    if (comment.canEdit) {
      const { i18n } = this;

      return (
        <Button
          {...bemClassesComment('btn')}
          onClick={this.edit}
          iconType={iconTypes.edit}
          title={i18n('commentBtnEditText')}
          label={i18n('commentBtnEditText')}
          inListDD
          data-test="editBtn"
        />
      );
    }
    return null;
  }

  renderDeleteBtn(comment) {
    if (comment.canDelete) {
      const { i18n } = this;

      return (
        <Button
          {...bemClassesComment('btn')}
          onClick={this.delete}
          iconType={iconTypes.delete}
          title={i18n('commentBtnDelText')}
          label={i18n('commentBtnDelText')}
          inListDD
        />
      );
    }
    return null;
  }

  renderPermissionsBlock({ authenticated }, userIp) { // eslint-disable-line
    const { reply } = this.state;
    const { noInteraction } = this.props;

    if (!noInteraction && authenticated) {
      // TODO: check for admin permissions
      // if (allRules) {
      //   return (
      //     <div {...bemClassesComment('menuAdmin')}>
      //       <span {...bemClassesComment('menuAdminIp')}>
      //         <span {...bemClassesComment('text')}>{userIp}</span>
      //       </span>
      //     </div>
      //   );
      // }
      if (reply) return <CommentRules dataView="btnPageCommentReply" />;

      return null;
    }

    return null;
  }

  renderDropDown(comment) {
    const { i18n } = this;
    const { highlighted } = this.state;
    const pageUrl = `${this.router.location.pathname}#comment-${this.props.comment.id}`;

    return (
      <DropDown
        {...bemClassesDD()}
        ref={ref => this.ddRef = ref}
        modalHeader={i18n('commentModalHeader')}
        modalCommonProps={{
          className: 'modalMoreComment'
        }}
        alwaysDD
        inForm
        wAuto
        list
      >
        <Button
          {...bemClassesDD('btn', { more: true, highlighted })}
          iconType={iconTypes.moreVertical}
          iconOnly
        />
        <div {...bemClassesDD('contentContainer')} data-test="contentContainer">
          <div {...bemClassesDD('content')} data-test="content">
            <Button
              onClick={this.clipboardListener}
              iconType={iconTypes.copyLink}
              title={i18n('commentBtnCopyText')}
              label={i18n('commentBtnCopyText')}
              inListDD
            />
            {/*
            <Share
              title={i18n('commentBtnShareTitle')}
              project="domik"
              onClose={this.closeDropDown}
              inListDD
            />
            */}
            <Complaint
              entity="comment"
              entityId={comment.id}
              closeDropDown={this.closeDropDown}
              withIcon
              inListDD
              url={pageUrl}
            />
            {this.renderEditBtn(comment)}
            {this.renderDeleteBtn(comment)}
          </div>
        </div>
      </DropDown>
    );
  }

  renderVoting(comment) {
    const { i18n } = this;

    return (
      <div {...bemClassesComment('menuVoting')} data-test="menuVoting">
        <Button
          {...bemClassesComment('btn', 'voting_down')}
          onClick={this.voteMinus}
          title={i18n('commentBtnVotingTitle')}
          iconType={iconTypes.votingDown}
          iconOnly
        />
        <span {...bemClassesComment('text', 'voting_down')} data-test="votingDown">{comment.rating_m || 0}</span>
        <span {...bemClassesComment('menuVotingSeparate')} />
        <Button
          {...bemClassesComment('btn', 'voting_up')}
          onClick={this.votePlus}
          title={i18n('commentBtnVotingTitle')}
          iconType={iconTypes.votingUp}
          iconOnly
        />
        <span {...bemClassesComment('text', 'voting_up')} data-test="votingUp">+{comment.rating_p || 0}</span>
      </div>
    );
  }

  renderComment(comment) {
    if (this.state.editing) {
      return this.renderEditor({
        className: 'commentsEditor commentsEditor_editing',
        id: comment.id,
        updateEvent: `ed::${comment.id}`,
        onCommentSubmit: this.editSubmitted,
        onCancel: () => this.setState({ editing: !this.state.editing })
      });
    }

    const { i18n } = this;
    const { auth, noInteraction } = this.props;
    const replyToName = get(comment, 'reply_to_name');

    return (
      <div
        {...bemClassesComment('content')}
        ref={ref => this.comment = ref}
      >
        <div {...bemClassesComment('imgContainer')}>
          <div {...bemClassesComment('img')}>
            {comment.avatar ?
              <Thumb
                {...bemClassesComment('imgPic')}
                image={{ id: comment.avatar }}
              /> :
              <Icon {...bemClassesComment('icon')} type={iconTypes.personCircle} />
            }
          </div>
        </div>
        <div {...bemClassesComment('imgException')}>
          <div {...bemClassesComment('top')}>
            <div {...bemClassesComment('topContent')}>
              <span {...bemClassesComment('userName')} children={this.showUserName(comment)} />
              <span {...bemClassesComment('dateAdd')}>
                <span {...bemClassesComment('dateAddSeparate')}>
                  <span {...bemClassesComment('text')}>&bull;&ensp;</span>
                </span>
                <time
                  {...bemClassesComment('text')}
                  dateTime={comment.date_add}
                  children={formatDate({
                    date: comment.date_add,
                    format: 'dd.mm.yyyy HH:MM'
                  })}
                />
              </span>
              {!noInteraction && this.state.isNew &&
                <span {...bemClassesComment('isNew')}>
                  <span {...bemClassesComment('text')} children={i18n('commentIsNewText')} />
                </span>
              }
            </div>
            {!noInteraction && this.renderDropDown(comment)}
          </div>
          <div
            {...bemClassesComment('post')}
            ref={ref => this.commentPost = ref}
          >
            {replyToName &&
              <>
                <span {...bemClassesComment('link')}>
                  <span {...bemClassesComment('linkContent')}>
                    <span {...bemClassesComment('text')} children={replyToName} />
                  </span>
                </span>,
              </>
            }
            <div
              {...bemClassesComment('text')}
              dangerouslySetInnerHTML={{ __html: comment.post }}
            />
          </div>
          <div {...bemClassesComment('menu')}>
            <div {...bemClassesComment('menuContent')}>
              {this.renderPermissionsBlock(auth, comment.user_ip)}
              <div {...bemClassesComment('menuMain')} data-test="menuMain">
                {!this.state.reply && comment.canReply &&
                  <Button
                    {...bemClassesComment('btn', 'reply')}
                    onClick={this.reply}
                    title={i18n('commentBtnReplyTitle')}
                    iconType={iconTypes.reply}
                    iconOnly
                    data-test="replyBtn"
                  />
                }
              </div>
              {!noInteraction && this.renderVoting(comment)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { comment } = this.props;
    const { showPopup } = this.state;

    return (
      <div {...bemClassesComment(null, `level_${comment.level}`)}>
        {this.renderComment(comment)}
        {this.renderReply()}
        {showPopup &&
          <FullScreenSlider
            images={this.images[this.imageSource]}
            selectedImage={this.selectedImageIndex}
            onCloseCallback={() => {
              this.setState(
                { showPopup: false },
                () => noScroll()
              );
            }}
          />
        }
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'Comment',
            creator: {
              '@type': 'Person',
              name: comment.user_add_name,
              image: absoluteUrl(`/images/thumb/full/${comment.avatar}`)
            },
            datePublished: comment.date_add,
            parentItem: comment.reply_to_name,
            text: comment.post
          }}
        />
      </div>
    );
  }
}
